import { createSlashCommand } from '@/components/tiptap/sharedExtensions/slash-command';
import { getGroups } from './group';

export const SlashCommand = createSlashCommand({ getGroups });
